export class DetalleServicioSeleccionado {
    constructor(
        public cantidad: number,
        public condicion: number,
        public observacion: string,
        public tiempo?: number
    ) {
        this.cantidad = cantidad;
        this.condicion = condicion;
        this.observacion = observacion;
        this.tiempo = tiempo;
    }
}
